module.exports = __webpack_public_path__ + "static/media/20180825_143750.a07a3047.jpg";